// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2thLc","toggle":"styles_toggle__ht125","preview":"styles_preview__1Jven"};